(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    let returnFocusTo = null;
    let lastAddedQty = 1;

    const refresh = async () => {
      const doc = await window.AB.fetchSection('cart-drawer');
      const fresh = doc.getElementById('cart-drawer-inner');
      if (fresh) {
        const current = document.getElementById('cart-drawer-inner');
        window.AB.keepPickupSlots(current, fresh);
        current.replaceWith(fresh);
      }
      document.dispatchEvent(new CustomEvent('ab:content:loaded'));
    };

    /* "Dodano do koszyka": show only the line that was just added (spec §5 / mockup 7c).
       `quantity` is the amount added in this action, not the line total. */
    const showAdded = (item, quantity) => {
      const inner = document.getElementById('cart-drawer-inner');
      const headDefault = inner.querySelector('[data-drawer-head-default]');
      const headAdded = inner.querySelector('[data-drawer-head-added]');
      const slot = inner.querySelector('[data-drawer-added]');
      if (!item || !slot) return;
      const row = inner.querySelector('[data-key="' + CSS.escape(item.key) + '"]');
      if (!row) return;
      const clone = row.cloneNode(true);
      clone.classList.add('cart-drawer__item--added');
      clone.removeAttribute('data-key');
      const qtyAdded = parseInt(quantity || item.quantity, 10) || 1;
      lastAddedQty = qtyAdded;
      const meta = clone.querySelector('[data-variant-line]');
      if (meta) {
        const base = meta.dataset.base || '';
        const qtyText = (meta.dataset.qtyTemplate || '%q').replace('%q', qtyAdded);
        meta.textContent = base ? base + ' · ' + qtyText : qtyText;
      }
      const rowControls = clone.querySelector('.cart-drawer__item-row');
      if (rowControls) {
        const price = rowControls.querySelector('[data-line-price]');
        rowControls.innerHTML = '';
        if (price) rowControls.appendChild(price);
      }
      const remove = clone.querySelector('.cart-drawer__remove');
      if (remove) remove.remove();
      slot.innerHTML = '';
      slot.appendChild(clone);
      slot.hidden = false;
      inner.dataset.mode = 'added';
      if (headDefault) headDefault.hidden = true;
      if (headAdded) headAdded.hidden = false;
    };

    const open = async (added) => {
      if (!drawer.open) returnFocusTo = (added && added.trigger) || document.activeElement;
      await refresh();
      if (added && added.item) showAdded(added.item, added.quantity);
      if (!drawer.open) drawer.showModal();
      const closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    };

    const close = () => {
      if (!drawer.open || drawer.classList.contains('cart-drawer--closing')) return;
      drawer.classList.add('cart-drawer--closing');
      drawer.addEventListener(
        'animationend',
        () => {
          drawer.classList.remove('cart-drawer--closing');
          drawer.close();
          if (returnFocusTo && typeof returnFocusTo.focus === 'function') returnFocusTo.focus({ preventScroll: true });
          returnFocusTo = null;
        },
        { once: true }
      );
    };

    drawer.addEventListener('cancel', (e) => {
      e.preventDefault();
      close();
    });

    window.AmmoCartDrawer = { open, refresh, close };

    document.addEventListener('cart:added', (e) => open(e.detail || {}));

    const changeLine = async (line, quantity) => {
      try {
        await window.AB.cart.change({ line, quantity });
      } finally {
        await refresh();
      }
    };

    drawer.addEventListener('click', async (e) => {
      if (e.target === drawer) {
        close();
        return;
      }
      if (e.target.closest('[data-drawer-close]')) {
        close();
        return;
      }
      const lineBtn = e.target.closest('[data-line][data-qty]');
      if (lineBtn) {
        lineBtn.disabled = true;
        await changeLine(parseInt(lineBtn.dataset.line, 10), Math.max(0, parseInt(lineBtn.dataset.qty, 10)));
        return;
      }
      const addBtn = e.target.closest('[data-drawer-add]');
      if (addBtn) {
        addBtn.disabled = true;
        let added = null;
        try {
          added = await window.AB.cart.add({ id: parseInt(addBtn.dataset.drawerAdd, 10), quantity: 1 }, { silent: true });
        } catch (err) {
          window.AB.toast(err.message || window.AB.t.error);
        } finally {
          await refresh();
          if (added) showAdded(added, 1);
        }
      }
    });

    drawer.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-line-input]');
      if (!input) return;
      await changeLine(parseInt(input.dataset.lineInput, 10), Math.max(0, parseInt(input.value || '0', 10)));
    });

    /* COAL (spec §8): the shared modal (snippets/coal-modal) emits coal:save */
    document.addEventListener('coal:save', async (e) => {
      const { line, quantity, variantId, properties, trigger } = e.detail || {};
      if (!trigger || !drawer.contains(trigger)) return;
      const wasAdded = document.getElementById('cart-drawer-inner').dataset.mode === 'added';
      let cart = null;
      try {
        cart = await window.AB.cart.change({ line, quantity, properties });
      } catch (err) {
        window.AB.toast(err.message || window.AB.t.error);
      }
      await refresh();
      // Stay in the "Dodano do koszyka" view; the line key changes with its properties, so look the line up again
      if (wasAdded && cart) {
        const item =
          cart.items.find(
            (i) =>
              i.variant_id === variantId &&
              i.properties &&
              i.properties['Elaboracja'] === properties['Elaboracja'] &&
              (i.properties['COAL (mm)'] || '') === (properties['COAL (mm)'] || '')
          ) || cart.items[line - 1];
        if (item) showAdded(item, lastAddedQty);
      }
      const btn = drawer.querySelector('[data-coal-open][data-coal-line="' + line + '"]');
      if (btn) btn.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const AB = window.AB;
    const page = () => document.querySelector('[data-cart-page]');
    if (!page()) return;
    const sectionId = page().dataset.sectionId;
    const money = (c) => AB.money(c);

    /* ---- Re-render the section after every cart mutation ----------------- */
    let busy = false;
    const rerender = async () => {
      const doc = await AB.fetchSection(sectionId, AB.routes.cart);
      const fresh = doc.querySelector('[data-cart-page]');
      const current = page();
      if (fresh && current) {
        AB.keepPickupSlots(current, fresh);
        const curNote = current.querySelector('[data-note-input]');
        const freshNote = fresh.querySelector('[data-note-input]');
        if (curNote && freshNote && curNote.value !== freshNote.value) {
          freshNote.value = curNote.value;
          const freshField = fresh.querySelector('[data-note-field]');
          const freshToggle = fresh.querySelector('[data-note-toggle]');
          if (freshField) freshField.classList.remove('is-collapsed');
          if (freshToggle) freshToggle.hidden = true;
        }
        current.replaceWith(fresh);
        init();
        document.dispatchEvent(new CustomEvent('ab:content:loaded'));
      }
    };
    const mutate = async (fn) => {
      if (busy) return;
      busy = true;
      page().classList.add('cart-page--busy');
      try {
        await fn();
      } catch (err) {
        AB.toast((err && err.message) || AB.t.error);
      } finally {
        busy = false;
        await rerender();
      }
    };

    document.addEventListener('click', (e) => {
      const change = e.target.closest('[data-cart-change]');
      if (change && page().contains(change)) {
        mutate(() => AB.cart.change({ line: parseInt(change.dataset.line, 10), quantity: Math.max(0, parseInt(change.dataset.qty, 10)) }));
        return;
      }
      const add = e.target.closest('[data-cart-add]');
      if (add && page().contains(add)) {
        add.disabled = true;
        mutate(() => AB.cart.add({ id: parseInt(add.dataset.cartAdd, 10), quantity: 1 }, { silent: true }));
      }
    });
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-qty-input]');
      if (input && page().contains(input)) {
        mutate(() => AB.cart.change({ line: parseInt(input.dataset.line, 10), quantity: Math.max(0, parseInt(input.value || '0', 10)) }));
      }
    });

    /* ---- Delivery estimator + totals (spec §6.4) ------------------------- */
    /* Globe Pickup Points widget in #ab-pickup-cart replaces the estimator's method radios:
       the "Dostawa" row follows the widget's checked card (home price, or the chosen point's
       price); "od …" or no choice yet → "przy kasie" and no shipping in the total. */
    const parseCents = (text) => {
      if (!text || /^od\b/i.test(text)) return null;
      const m = text.replace(/\s/g, '').match(/(\d+(?:[.,]\d{1,2})?)/);
      return m ? Math.round(parseFloat(m[1].replace(',', '.')) * 100) : 0;
    };
    const globeChoice = (p) => {
      const widget = p.querySelector('#ab-pickup-cart .globe-delivery-selector-container');
      if (!widget) return null;
      const option = widget.querySelector('.globe-delivery-option input:checked')?.closest('.globe-delivery-option');
      if (!option) return { label: p.dataset.shipCheckout, cents: null };
      const isPickup = option.dataset.deliveryMethod === 'pickup';
      // Pickup card: first price is "od …" (cheapest), the chosen point's price comes after it
      const prices = [...option.querySelectorAll('.globe-delivery-price')].map((el) => el.textContent.trim()).filter(Boolean);
      let text = isPickup ? prices.find((t) => !/^od\b/i.test(t)) : prices[0];
      if (isPickup && !text) text = globePointPrice(option.textContent.replace(/\s+/g, ' ').trim());
      return { name: isPickup ? p.dataset.shipPickup : p.dataset.shipHome, text, cents: parseCents(text) };
    };
    /* After a reload Globe sometimes leaves the chosen point's price empty. Ask Globe's own rate
       helper for it, using the point saved in the cart attributes — once per point; if the helper
       is missing or fails, the row keeps "przy kasie". */
    const pointPrice = { key: null, text: null, pending: false };
    const globePointPrice = (key) => {
      if (pointPrice.key === key) return pointPrice.text;
      if (pointPrice.pending || !window.__globeRates?.labelForPoint) return null;
      pointPrice.pending = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((cart) => {
          const point = JSON.parse(cart.attributes?.globe_PickupPointData || 'null');
          if (!point?.providerShopId) return '';
          return window.__globeRates.labelForPoint(point.providerShopId, point.shippingMethods);
        })
        .then((label) => (pointPrice.text = label || null))
        .catch(() => (pointPrice.text = null))
        .finally(() => {
          pointPrice.key = key;
          pointPrice.pending = false;
          computeTotals();
        });
      return null;
    };
    const computeTotals = () => {
      const p = page();
      if (!p) return;
      const subtotal = parseInt(p.dataset.subtotal || '0', 10);
      const free = p.dataset.freeShipping === 'true';
      const checked = p.querySelector('[data-methods] input:checked');
      const shipName = p.querySelector('[data-ship-name]');
      const shipPrice = p.querySelector('[data-ship-price]');
      let shipping = 0;
      const globe = globeChoice(p);
      p.classList.toggle('cart-page--globe', !!globe);
      if (globe) {
        if (globe.cents === null || globe.cents === undefined) {
          if (shipName) shipName.textContent = globe.name || '';
          if (shipPrice) shipPrice.textContent = p.dataset.shipCheckout;
        } else {
          shipping = globe.cents;
          if (shipName) shipName.textContent = globe.name;
          if (shipPrice) shipPrice.textContent = shipping > 0 ? money(shipping) : globe.text || money(0);
        }
      } else if (checked) {
        shipping = free ? 0 : parseInt(checked.dataset.cents || '0', 10);
        if (shipName) shipName.textContent = checked.dataset.short || checked.value;
        if (shipPrice) shipPrice.textContent = free ? shipPrice.textContent || money(0) : money(shipping);
      }
      const total = subtotal + shipping;
      p.querySelectorAll('[data-grand-total]').forEach((el) => (el.textContent = money(total)));
    };
    document.addEventListener('change', async (e) => {
      const radio = e.target.closest('[data-methods] input[type="radio"]');
      if (!radio || !page().contains(radio)) return;
      computeTotals();
      try {
        await AB.cart.update({ attributes: { 'Preferowana dostawa': radio.value } });
      } catch (err) {}
    });

    /* ---- Discount code (hidden behind a link) ---------------------------- */
    const readCookie = (name) => {
      const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    };
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-discount-toggle]');
      if (!toggle || !page().contains(toggle)) return;
      const form = page().querySelector('[data-discount-form]');
      const open = form.hidden;
      form.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) form.querySelector('input').focus();
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-discount-form]');
      if (!form || !page().contains(form)) return;
      e.preventDefault();
      const code = form.querySelector('input').value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(AB.routes.cart);
    });
    const showAppliedCode = () => {
      const el = page().querySelector('[data-discount-applied]');
      const code = readCookie('discount_code');
      if (!el) return;
      if (code) {
        el.textContent = el.dataset.template.replace('%c', code);
        el.hidden = false;
        const toggle = page().querySelector('[data-discount-toggle]');
        if (toggle) toggle.hidden = true;
      }
    };

    /* ---- Order note (hidden behind a link, saved to cart.note) ----------- */
    const noteInput = () => page().querySelector('[data-note-input]');
    let noteSaved = (noteInput() && noteInput().value) || '';
    let noteTimer = null;
    let noteStatusTimer = null;
    const setNoteStatus = (saved) => {
      const status = page().querySelector('[data-note-status]');
      if (!status) return;
      status.hidden = !saved;
      clearTimeout(noteStatusTimer);
      if (saved) noteStatusTimer = setTimeout(() => setNoteStatus(false), 2500);
    };
    const saveNote = async () => {
      clearTimeout(noteTimer);
      const input = noteInput();
      if (!input) return;
      const value = input.value;
      if (value === noteSaved) return;
      try {
        await AB.cart.update({ note: value });
        noteSaved = value;
        if (value.trim()) setNoteStatus(true);
      } catch (err) {}
    };
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-note-toggle]');
      if (!toggle || !page().contains(toggle)) return;
      const field = page().querySelector('[data-note-field]');
      field.classList.remove('is-collapsed');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
      field.querySelector('textarea').focus();
    });
    document.addEventListener('input', (e) => {
      if (!e.target.matches('[data-note-input]') || !page().contains(e.target)) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 600);
    });
    document.addEventListener('focusout', (e) => {
      if (!e.target.matches || !e.target.matches('[data-note-input]') || !page().contains(e.target)) return;
      saveNote();
    });
    /* Checkout forms: send the note along as a form field so it is stored even if the fetch did not finish */
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.querySelector || !form.querySelector('button[name="checkout"]') || !page().contains(form)) return;
      const input = noteInput();
      if (!input) return;
      let hidden = form.querySelector('input[name="note"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'note';
        form.appendChild(hidden);
      }
      hidden.value = input.value;
    });

    /* ---- Save for later (spec §6.2) --------------------------------------- */
    const savedKey = () => 'ab:saved:' + page().dataset.currency + ':' + page().dataset.customer;
    const guestKey = () => 'ab:saved:' + page().dataset.currency + ':guest';
    const readSaved = () => {
      try {
        return JSON.parse(localStorage.getItem(savedKey()) || '[]');
      } catch (e) {
        return [];
      }
    };
    const writeSaved = (list) => {
      try {
        localStorage.setItem(savedKey(), JSON.stringify(list));
      } catch (e) {}
    };
    const mergeGuestIntoAccount = () => {
      if (page().dataset.customer === 'guest') return;
      try {
        const guest = JSON.parse(localStorage.getItem(guestKey()) || '[]');
        if (!guest.length) return;
        const mine = readSaved();
        guest.forEach((g) => {
          if (!mine.some((m) => m.id === g.id)) mine.push(g);
        });
        writeSaved(mine);
        localStorage.removeItem(guestKey());
      } catch (e) {}
    };
    // Prices in localStorage are from the moment of saving — refresh them from /products/{handle}.js
    const priceCache = {};
    const refreshSavedPrices = async (saved) => {
      const handles = Array.from(new Set(saved.map((s) => s.handle).filter(Boolean))).slice(0, 12);
      let changed = false;
      await Promise.all(
        handles.map(async (handle) => {
          try {
            if (!priceCache[handle]) {
              const res = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
              if (!res.ok) return;
              priceCache[handle] = await res.json();
            }
            const product = priceCache[handle];
            saved.forEach((s) => {
              if (s.handle !== handle) return;
              const v = (product.variants || []).find((x) => x.id === s.id);
              if (v && (v.price !== s.price || v.available !== s.available)) {
                s.price = v.price;
                s.available = v.available;
                changed = true;
              }
            });
          } catch (e) {}
        })
      );
      return changed;
    };
    const renderSaved = (opts = {}) => {
      const p = page();
      const wrap = p.querySelector('[data-saved-wrap]');
      const list = p.querySelector('[data-saved-list]');
      const empty = p.querySelector('[data-saved-empty]');
      const tpl = p.querySelector('[data-saved-item-template]');
      if (!wrap || !list || !tpl) return;
      const saved = readSaved();
      list.innerHTML = '';
      // The header heart links to /cart#saved — show an explicit empty state there instead of nothing
      const wantsSaved = window.location.hash === '#saved';
      wrap.hidden = saved.length === 0 && !wantsSaved;
      if (empty) empty.hidden = saved.length > 0;
      if (saved.length && !opts.refreshed) {
        refreshSavedPrices(saved).then((changed) => {
          if (changed) {
            writeSaved(saved);
            renderSaved({ refreshed: true });
          }
        });
      }
      saved.forEach((s) => {
        const node = tpl.content.firstElementChild.cloneNode(true);
        node.dataset.id = s.id;
        const img = node.querySelector('img');
        if (s.image) img.src = s.image;
        else img.remove();
        node.querySelector('.saved-item__media').href = s.url;
        const title = node.querySelector('.saved-item__title');
        title.href = s.url;
        title.textContent = s.title;
        node.querySelector('.saved-item__variant').textContent = s.variant_title || '';
        node.querySelector('.saved-item__price').textContent = money(s.price) + (s.qty > 1 ? ' × ' + s.qty : '');
        if (s.available === false) {
          const move = node.querySelector('[data-saved-move]');
          if (move) {
            move.disabled = true;
            move.textContent = (window.AB.t && window.AB.t.unavailable) || move.textContent;
          }
        }
        list.appendChild(node);
      });
    };
    window.addEventListener('hashchange', () => renderSaved());
    document.addEventListener('click', async (e) => {
      const save = e.target.closest('[data-save-later]');
      if (save && page().contains(save)) {
        const row = save.closest('.cart-item');
        const item = {
          id: parseInt(row.dataset.variantId, 10),
          handle: row.dataset.handle,
          title: row.dataset.title,
          variant_title: row.dataset.variantTitle,
          price: parseInt(row.dataset.price, 10),
          qty: parseInt(row.dataset.qty, 10),
          image: row.dataset.image,
          url: row.dataset.url,
          properties: (() => {
            try {
              const parsed = JSON.parse(row.dataset.properties || '{}');
              return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
            } catch (err) {
              return {};
            }
          })(),
        };
        const list = readSaved().filter((s) => s.id !== item.id);
        list.unshift(item);
        writeSaved(list);
        mutate(() => AB.cart.change({ line: parseInt(row.dataset.line, 10), quantity: 0 }));
        return;
      }
      const remove = e.target.closest('[data-saved-remove]');
      if (remove && page().contains(remove)) {
        const id = parseInt(remove.closest('.saved-item').dataset.id, 10);
        writeSaved(readSaved().filter((s) => s.id !== id));
        renderSaved();
        return;
      }
      const move = e.target.closest('[data-saved-move]');
      if (move && page().contains(move)) {
        const id = parseInt(move.closest('.saved-item').dataset.id, 10);
        const saved = readSaved().find((s) => s.id === id);
        if (!saved) return;
        move.disabled = true;
        try {
          // Validate availability before moving back
          const res = await fetch('/products/' + saved.handle + '.js', { headers: { Accept: 'application/json' } });
          const product = await res.json();
          const variant = (product.variants || []).find((v) => v.id === id);
          if (!variant || !variant.available) {
            AB.toast(AB.t.unavailable || 'Unavailable');
            move.disabled = false;
            return;
          }
          await mutate(() => AB.cart.add({ id, quantity: saved.qty || 1, properties: saved.properties || {} }, { silent: true }));
          writeSaved(readSaved().filter((s) => s.id !== id));
          renderSaved();
        } catch (err) {
          AB.toast(AB.t.error);
          move.disabled = false;
        }
      }
    });

    /* ---- COAL (spec §8): the shared modal (snippets/coal-modal) emits coal:save */
    document.addEventListener('coal:save', (e) => {
      const { line, quantity, properties, trigger } = e.detail || {};
      if (!page() || !trigger || !page().contains(trigger)) return;
      mutate(() => AB.cart.change({ line, quantity, properties }));
    });

    /* The widget renders and updates asynchronously — recompute whenever its slot changes */
    let globeObserver = null;
    let globeFrame = 0;
    const watchGlobe = () => {
      if (globeObserver) globeObserver.disconnect();
      const slot = document.getElementById('ab-pickup-cart');
      if (!slot || !window.MutationObserver) return;
      globeObserver = new MutationObserver(() => {
        cancelAnimationFrame(globeFrame);
        globeFrame = requestAnimationFrame(computeTotals);
      });
      globeObserver.observe(slot, { childList: true, subtree: true, characterData: true });
    };
    document.addEventListener('change', (e) => {
      if (e.target.closest('#ab-pickup-cart')) requestAnimationFrame(computeTotals);
    });

    const init = () => {
      watchGlobe();
      computeTotals();
      showAppliedCode();
      mergeGuestIntoAccount();
      renderSaved();
    };
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-collection]');
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    const STORE_KEY = 'ab:cf:open';
    const RESTORE_PREFIX = 'ab:col:';

    /* ---- Filter group open/closed state (sessionStorage) ---------------- */
    const readOpen = () => {
      try {
        return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
      } catch (e) {
        return {};
      }
    };
    const applyOpenState = () => {
      const state = readOpen();
      document.querySelectorAll('[data-cf-group]').forEach((d) => {
        const key = d.dataset.cfGroup;
        if (key in state) d.open = !!state[key];
        if (!d.dataset.bound) {
          d.dataset.bound = '1';
          d.addEventListener('toggle', () => {
            const s = readOpen();
            s[key] = d.open;
            try {
              sessionStorage.setItem(STORE_KEY, JSON.stringify(s));
            } catch (e) {}
          });
        }
      });
    };

    /* ---- Caliber search + "show all" ------------------------------------ */
    const bindCaliberTools = () => {
      document.querySelectorAll('[data-cf-search]').forEach((input) => {
        if (input.dataset.bound) return;
        input.dataset.bound = '1';
        const cloud = document.getElementById(input.dataset.cfSearch);
        if (!cloud) return;
        const noRes = cloud.querySelector('[data-cf-noresults]');
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase().replace(/×/g, 'x').replace(/\s*x\s*/g, 'x').replace(/,/g, '.');
          cloud.classList.toggle('cf-groups--searching', q.length > 0);
          let hits = 0;
          cloud.querySelectorAll('[data-cf-label]').forEach((row) => {
            const label = row.dataset.cfLabel.replace(/×/g, 'x').replace(/\s*x\s*/g, 'x').replace(/,/g, '.');
            const match = q.length > 0 && label.includes(q);
            row.classList.toggle('cf-check--match', match);
            if (match) hits += 1;
          });
          if (noRes) noRes.hidden = !(q.length > 0 && hits === 0);
        });
      });
      document.querySelectorAll('[data-cf-more]:not([data-next-url])').forEach((btn) => {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        const cloud = btn.closest('[data-cf-groups]');
        const overflow = cloud.querySelectorAll('.cf-check--overflow').length;
        if (overflow === 0) btn.hidden = true;
        btn.dataset.labelMore = btn.textContent.trim();
        btn.addEventListener('click', () => {
          const open = cloud.classList.toggle('cf-groups--open');
          btn.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore;
        });
      });
    };

    /* ---- AJAX filtering with URL sync (spec §3.1 requirement) ----------- */
    let busy = false;
    let requestSeq = 0;
    const main = () => root.querySelector('[data-cf-main]');

    const buildUrl = (form) => {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (value === '' || value === null) return;
        params.append(key, value);
      });
      const url = new URL(root.dataset.collectionUrl, window.location.origin);
      url.search = params.toString();
      return url;
    };

    const swap = async (url, { push = true, focusSelector = null } = {}) => {
      const seq = ++requestSeq;
      busy = true;
      root.classList.add('collection--loading');
      const m = main();
      if (m) m.setAttribute('aria-busy', 'true');
      try {
        const doc = await window.AB.fetchSection(sectionId, url.toString());
        if (seq !== requestSeq) return;
        const fresh = doc.querySelector('[data-collection]');
        if (!fresh) {
          window.location.href = url.toString();
          return;
        }
        // Replace everything but keep the scroll position of the sidebar
        const sidebar = root.querySelector('.collection__sidebar');
        const sidebarScroll = sidebar ? sidebar.scrollTop : 0;
        root.innerHTML = fresh.innerHTML;
        root.dataset.page = fresh.dataset.page;
        root.dataset.pages = fresh.dataset.pages;
        root.dataset.total = fresh.dataset.total;
        const freshSheet = doc.getElementById('filter-sheet');
        const sheet = document.getElementById('filter-sheet');
        if (freshSheet && sheet) {
          const wasOpen = sheet.open;
          sheet.innerHTML = freshSheet.innerHTML;
          if (wasOpen && !sheet.open) sheet.showModal();
        }
        if (push) window.history.pushState({ ab: 'collection' }, '', url.toString());
        const newSidebar = root.querySelector('.collection__sidebar');
        if (newSidebar) newSidebar.scrollTop = sidebarScroll;
        afterRender();
        if (focusSelector) {
          const el = document.querySelector(focusSelector);
          if (el) el.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('ab:content:loaded'));
      } catch (err) {
        window.location.href = url.toString();
      } finally {
        if (seq === requestSeq) {
          busy = false;
          root.classList.remove('collection--loading');
          const mm = main();
          if (mm) mm.setAttribute('aria-busy', 'false');
        }
      }
    };

    const onFormChange = (form, target) => {
      const url = buildUrl(form);
      const focusSelector = target && target.id ? '#' + CSS.escape(target.id) : null;
      swap(url, { focusSelector });
    };

    let debounceTimer;
    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-cf-form]');
      if (form) {
        if (e.target.matches('[data-cf-debounce]')) return; // handled on input
        // keep both forms' sort in sync
        onFormChange(form, e.target);
        return;
      }
      if (e.target.matches('[data-cf-sort-select]')) {
        document.querySelectorAll('[data-cf-sort]').forEach((i) => (i.value = e.target.value));
        const f = document.getElementById('cf-desktop') || document.getElementById('cf-sheet');
        if (f) onFormChange(f, e.target);
        else {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', e.target.value);
          swap(url);
        }
      }
    });
    document.addEventListener('input', (e) => {
      if (!e.target.matches('[data-cf-debounce]')) return;
      const form = e.target.closest('[data-cf-form]');
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => onFormChange(form, e.target), 600);
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-cf-form]');
      if (!form) return;
      e.preventDefault();
      onFormChange(form);
    });
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-cf-link], [data-cf-clear]');
      if (!link || !root.contains(link) && !document.getElementById('filter-sheet').contains(link)) return;
      e.preventDefault();
      swap(new URL(link.href, window.location.origin));
    });

    window.addEventListener('popstate', () => {
      swap(new URL(window.location.href), { push: false });
    });

    /* ---- "Pokaż więcej" + restore on back (spec §3.4) ------------------- */
    const restoreKey = () => RESTORE_PREFIX + window.location.pathname + window.location.search;
    const saveState = () => {
      const grid = root.querySelector('[data-cf-grid]');
      const more = root.querySelector('[data-cf-more][data-next-url]');
      const shownText = root.querySelector('[data-cf-shown-text]');
      const bar = root.querySelector('[data-cf-shown-bar]');
      if (!grid) return;
      try {
        sessionStorage.setItem(
          restoreKey(),
          JSON.stringify({
            html: grid.innerHTML,
            next: more ? more.dataset.nextUrl : null,
            shown: shownText ? shownText.textContent : '',
            bar: bar ? bar.style.width : '',
            total: root.dataset.total,
            scrollY: window.scrollY,
            t: Date.now(),
          })
        );
      } catch (e) {}
    };

    // "Pokazano X z Y" after appending a page: X = cards actually in the grid
    // (capacity families are deduplicated), Y = total from the first page, fixed
    // to X on the last page.
    const updateShown = (hasMore) => {
      const grid = root.querySelector('[data-cf-grid]');
      const shownText = root.querySelector('[data-cf-shown-text]');
      const bar = root.querySelector('[data-cf-shown-bar]');
      if (!grid) return;
      const shown = grid.querySelectorAll('[data-product-card]').length;
      let total = parseInt(root.dataset.total, 10) || 0;
      if (!hasMore) total = shown;
      else if (total <= shown) total = shown + 1;
      root.dataset.total = String(total);
      if (shownText && shownText.dataset.shownTemplate) {
        shownText.textContent = shownText.dataset.shownTemplate.replace('__SHOWN__', shown).replace('__TOTAL__', total);
      }
      if (bar) bar.style.width = (total > 0 ? Math.min(100, Math.round((shown / total) * 100)) : 100) + '%';
    };

    const setBusy = (btn, on) => {
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-disabled', on ? 'true' : 'false');
      if ('disabled' in btn) btn.disabled = on;
    };
    const loadMore = async (btn, depth = 0) => {
      if (busy && depth === 0) return;
      busy = true;
      const label = btn.dataset.labelMore || btn.textContent;
      btn.dataset.labelMore = label;
      btn.textContent = btn.dataset.labelLoading;
      setBusy(btn, true);
      try {
        const doc = await window.AB.fetchSection(sectionId, btn.dataset.nextUrl);
        const fresh = doc.querySelector('[data-collection]');
        const freshGrid = fresh && fresh.querySelector('[data-cf-grid]');
        const grid = root.querySelector('[data-cf-grid]');
        if (!freshGrid || !grid) throw new Error('no grid');
        // Skip capacity families already shown (siblings split across pages)
        const seen = new Set(
          Array.from(grid.querySelectorAll('[data-product-card][data-family]')).map((c) => c.dataset.family)
        );
        let firstNew = null;
        let appended = 0;
        Array.from(freshGrid.children).forEach((card) => {
          const fam = card.dataset ? card.dataset.family : null;
          if (fam && seen.has(fam)) return;
          if (fam) seen.add(fam);
          if (!firstNew) firstNew = card;
          grid.appendChild(card);
          appended += 1;
        });
        const freshMore = fresh.querySelector('[data-cf-more][data-next-url]');
        const pagination = root.querySelector('[data-cf-pagination]');
        const freshPagination = fresh.querySelector('[data-cf-pagination]');
        if (pagination && freshPagination) pagination.replaceWith(freshPagination);
        if (freshMore) {
          btn.dataset.nextUrl = freshMore.dataset.nextUrl;
          if (btn.tagName === 'A') btn.href = freshMore.dataset.nextUrl;
          btn.textContent = label;
          setBusy(btn, false);
        } else {
          btn.remove();
        }
        updateShown(!!freshMore);
        if (appended === 0 && freshMore && depth < 3) {
          // page held only already-shown siblings — fetch the next one right away
          await loadMore(btn, depth + 1);
          return;
        }
        if (firstNew) {
          const link = firstNew.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('ab:content:loaded'));
        saveState();
      } catch (err) {
        window.location.href = btn.dataset.nextUrl;
      } finally {
        if (depth === 0) busy = false;
      }
    };
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cf-more][data-next-url]');
      if (!btn || !root.contains(btn)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // let "open in new tab" work
      e.preventDefault();
      loadMore(btn);
    });

    const restore = () => {
      const nav = performance.getEntriesByType('navigation')[0];
      const isBack = nav && nav.type === 'back_forward';
      let saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(restoreKey()) || 'null');
      } catch (e) {}
      if (!saved) return;
      if (!isBack) {
        sessionStorage.removeItem(restoreKey());
        return;
      }
      const grid = root.querySelector('[data-cf-grid]');
      const more = root.querySelector('[data-cf-more][data-next-url]');
      const shownText = root.querySelector('[data-cf-shown-text]');
      const bar = root.querySelector('[data-cf-shown-bar]');
      if (grid) grid.innerHTML = saved.html;
      if (saved.total) root.dataset.total = saved.total;
      if (shownText && saved.shown) shownText.textContent = saved.shown;
      if (bar && saved.bar) bar.style.width = saved.bar;
      if (more) {
        if (saved.next) {
          more.dataset.nextUrl = saved.next;
          if (more.tagName === 'A') more.href = saved.next;
        } else more.remove();
      }
      document.dispatchEvent(new CustomEvent('ab:content:loaded'));
      requestAnimationFrame(() => window.scrollTo(0, saved.scrollY || 0));
    };

    // Remember scroll before leaving to a PDP
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-cf-grid] a');
      if (a) saveState();
    });

    const afterRender = () => {
      applyOpenState();
      bindCaliberTools();
    };
    afterRender();
    restore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // "Zapytaj o wycenę" buttons link here with ?temat=wycena (snippet quote-url):
  // the message gets a topic field and the textarea hints what a quote needs.
  (function () {
    if (new URLSearchParams(window.location.search).get('temat') !== 'wycena') return;
    var wrap = document.querySelector('[data-contact-quote]');
    var form = wrap && wrap.querySelector('form');
    if (!form) return;
    var topic = document.createElement('input');
    topic.type = 'hidden';
    topic.name = wrap.dataset.quoteField;
    topic.value = wrap.dataset.quoteTopic;
    form.prepend(topic);
    var message = form.querySelector('#contact-message');
    if (message) message.placeholder = wrap.dataset.quoteHint;
    var title = wrap.querySelector('[data-quote-title]');
    if (title) title.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cookie-settings]');
    const banner = window.privacyBanner;
    if (!link || !banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    banner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const form = header.querySelector('[data-sd-form]');
    const input = form.querySelector('input[name="q"]');
    const clearBtn = form.querySelector('[data-sd-clear]');
    const toggle = header.querySelector('[data-sd-toggle]');
    const panel = header.querySelector('[data-sd]');
    const backdrop = header.querySelector('[data-sd-backdrop]');
    const cfgEl = document.querySelector('[data-sd-config]');
    const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    const queriesWrap = panel.querySelector('[data-sd-queries-wrap]');
    const queriesEl = panel.querySelector('[data-sd-queries]');
    const collectionsWrap = panel.querySelector('[data-sd-collections-wrap]');
    const collectionsEl = panel.querySelector('[data-sd-collections]');
    const popularWrap = panel.querySelector('[data-sd-popular-wrap]');
    const headEl = panel.querySelector('[data-sd-head]');
    const productsCount = panel.querySelector('[data-sd-products-count]');
    const productsEl = panel.querySelector('[data-sd-products]');
    const allLink = panel.querySelector('[data-sd-all]');
    const emptyEl = panel.querySelector('[data-sd-empty]');
    const coalEl = panel.querySelector('[data-sd-coal]');
    const coalText = panel.querySelector('[data-sd-coal-text]');
    const escapeHtml = (s) =>
      String(s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

    /* ---- Product template on phones: back arrow (mockup 7b) --------------
       history.back() when we came from this shop; otherwise the href
       (product's collection) is followed as a fallback. */
    const backLink = header.querySelector('[data-header-back]');
    if (backLink) {
      backLink.addEventListener('click', (e) => {
        let sameOrigin = false;
        try {
          sameOrigin = document.referrer !== '' && new URL(document.referrer).origin === window.location.origin;
        } catch (err) {
          sameOrigin = false;
        }
        if (sameOrigin && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    }

    /* ---- Caliber normalisation (spec §7) ------------------------------
       "9x19", "9 x 19", "9mm", "9×19" → one canonical term; the dictionary is
       merchant-editable in the section settings: "canonical = alias, alias". */
    const squash = (s) =>
      s
        .toLowerCase()
        .replace(/×/g, 'x')
        .replace(/\s*x\s*/g, 'x')
        .replace(/,/g, '.')
        .replace(/\s+/g, ' ')
        .trim();
    const synonyms = [];
    (cfg.synonyms || '').split('\n').forEach((line) => {
      const [canonical, aliases] = line.split('=');
      if (!canonical || !aliases) return;
      const canon = canonical.trim();
      aliases.split(',').forEach((a) => {
        const alias = squash(a);
        if (alias) synonyms.push({ alias, canon });
      });
      synonyms.push({ alias: squash(canon), canon });
    });
    synonyms.sort((a, b) => b.alias.length - a.alias.length);

    const canonicalize = (raw) => {
      const q = squash(raw);
      for (const { alias, canon } of synonyms) {
        if (q === alias) return canon;
      }
      // Partial match: replace an alias that appears as a whole token
      for (const { alias, canon } of synonyms) {
        const re = new RegExp('(^|\\s)' + alias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|\\s)');
        if (re.test(q)) return q.replace(re, '$1' + canon + '$2');
      }
      return raw.trim();
    };

    // Keep the merchant's label ("6,5 Creedmoor") next to the normalised form used for matching
    const coalCalibers = (cfg.coalCalibers || '')
      .split(';')
      .map((c) => ({ label: c.trim(), norm: squash(c) }))
      .filter((c) => c.norm);
    const colorNames = (cfg.colorNames || '').split(',').map((c) => c.trim()).filter(Boolean);
    const seriesTags = (cfg.seriesTags || '').split(',').map((c) => c.trim()).filter(Boolean);

    /* ---- Open / close -------------------------------------------------- */
    let lastFocus = null;
    const position = () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        panel.style.left = '';
        panel.style.width = '';
        return;
      }
      // Right edge flush with the header content (mockup 7f: right = container padding)
      const inner = header.querySelector('.header__inner') || form;
      const innerRect = inner.getBoundingClientRect();
      const padRight = parseFloat(getComputedStyle(inner).paddingRight) || 0;
      const headerRect = header.getBoundingClientRect();
      const width = Math.min(720, headerRect.width - 32);
      let left = innerRect.right - padRight - headerRect.left - width;
      if (left < 16) left = 16;
      panel.style.width = width + 'px';
      panel.style.left = left + 'px';
    };
    const open = () => {
      if (!panel.hidden) return;
      lastFocus = document.activeElement;
      position();
      panel.hidden = false;
      backdrop.hidden = false;
      header.classList.add('header--search-open');
      input.setAttribute('aria-expanded', 'true');
    };
    // The field itself lives behind the magnifier toggle; closing the dropdown folds it back
    const isExpanded = () => header.classList.contains('header--search-expanded');
    const expand = () => {
      header.classList.add('header--search-expanded');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const collapse = () => {
      if (!isExpanded()) return;
      const hadFocus = form.contains(document.activeElement);
      header.classList.remove('header--search-expanded');
      toggle.setAttribute('aria-expanded', 'false');
      if (hadFocus) toggle.focus();
    };
    const close = () => {
      collapse();
      if (panel.hidden) return;
      panel.hidden = true;
      backdrop.hidden = true;
      header.classList.remove('header--search-open');
      input.setAttribute('aria-expanded', 'false');
    };
    window.AmmoSearch = {
      open: () => {
        expand();
        input.focus();
        open();
      },
      close,
    };

    toggle.addEventListener('click', () => {
      if (isExpanded()) {
        close();
      } else {
        window.AmmoSearch.open();
      }
    });
    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && (isExpanded() || !panel.hidden)) close();
    });
    document.addEventListener('click', (e) => {
      if (panel.hidden && !isExpanded()) return;
      if (header.contains(e.target)) return;
      close();
    });
    window.addEventListener('resize', () => {
      if (!panel.hidden) position();
    });

    clearBtn.addEventListener('click', () => {
      input.value = '';
      reset();
      input.focus();
    });

    /* ---- Keyboard navigation over suggestions (↑ / ↓ / Enter) ---------- */
    let activeIndex = -1;
    let keyboardPick = false;
    const options = () => Array.from(queriesEl.querySelectorAll('.sd__suggestion'));
    const setActive = (index, viaKeyboard) => {
      const opts = options();
      opts.forEach((o, n) => {
        o.classList.toggle('sd__suggestion--active', n === index);
        o.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      activeIndex = index;
      if (viaKeyboard && index >= 0 && opts[index]) {
        input.setAttribute('aria-activedescendant', opts[index].id);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };
    input.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      const opts = options();
      if (!opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        let next = activeIndex + (e.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) next = opts.length - 1;
        if (next >= opts.length) next = 0;
        keyboardPick = true;
        setActive(next, true);
      } else if (e.key === 'Enter' && keyboardPick && activeIndex >= 0 && opts[activeIndex]) {
        // Enter follows the arrow-selected suggestion; without arrows the form submits (spec §7)
        e.preventDefault();
        window.location.href = opts[activeIndex].href;
      }
    });

    /* ---- Rendering ----------------------------------------------------- */
    const reset = () => {
      clearBtn.hidden = true;
      queriesWrap.hidden = true;
      collectionsWrap.hidden = true;
      popularWrap.hidden = false;
      headEl.hidden = true;
      emptyEl.hidden = true;
      coalEl.hidden = true;
      productsEl.innerHTML = '';
      queriesEl.innerHTML = '';
      panel.classList.add('sd--idle');
      keyboardPick = false;
      setActive(-1, false);
    };

    const money = (amount) => (window.AB && window.AB.money ? window.AB.money(Math.round(parseFloat(amount) * 100)) : amount);

    const productMeta = (p) => {
      const parts = [];
      const tags = Array.isArray(p.tags) ? p.tags : [];
      const series = tags.find((t) => seriesTags.some((s) => s.toLowerCase() === String(t).toLowerCase()));
      if (series) parts.push(series);
      const colors = new Set();
      (p.variants || []).forEach((v) => {
        (v.options || []).forEach((o) => {
          const name = colorNames.find((c) => String(o).toLowerCase().includes(c.toLowerCase()));
          if (name) colors.add(o);
        });
      });
      if (colors.size) parts.push(Array.from(colors).join(', '));
      return parts.join(' · ');
    };

    let timer;
    let lastQuery = '';

    const runSearch = async (rawQuery) => {
      const query = canonicalize(rawQuery);
      const url =
        (cfg.suggestUrl || '/search/suggest.json') +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,query,collection&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      let data;
      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        data = await res.json();
      } catch (err) {
        return;
      }
      if (rawQuery !== lastQuery) return;
      const results = data.resources.results;
      const products = results.products || [];
      const queries = (results.queries || []).slice(0, 4);
      const collections = results.collections || [];

      popularWrap.hidden = true;
      panel.classList.remove('sd--idle');

      queriesWrap.hidden = queries.length === 0;
      queriesEl.innerHTML = '';
      queries.forEach((q, i) => {
        const a = document.createElement('a');
        a.className = 'sd__suggestion';
        a.id = 'sd-option-' + i;
        a.href = q.url;
        a.setAttribute('role', 'option');
        a.innerHTML = q.styled_text;
        queriesEl.appendChild(a);
      });
      keyboardPick = false;
      setActive(queries.length ? 0 : -1, false);

      collectionsWrap.hidden = collections.length === 0;
      collectionsEl.innerHTML = '';
      collections.forEach((c) => {
        const a = document.createElement('a');
        a.className = 'sd__collection';
        a.href = c.url;
        a.textContent = c.title;
        collectionsEl.appendChild(a);
      });

      allLink.href = cfg.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
      headEl.hidden = products.length === 0;
      emptyEl.hidden = products.length > 0;
      productsCount.textContent = products.length;

      productsEl.innerHTML = '';
      products.forEach((p) => {
        const row = document.createElement('a');
        row.className = 'sd__product';
        row.href = p.url;
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        row.innerHTML =
          '<span class="sd__product-media">' +
          (img ? '<img src="' + img + (img.includes('?') ? '&' : '?') + 'width=112" alt="" loading="lazy" width="56" height="56">' : '') +
          '</span>' +
          '<span class="sd__product-info"><span class="sd__product-title"></span><span class="sd__product-meta"></span></span>' +
          '<span class="sd__product-price"></span>' +
          '<span class="sd__product-chevron"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></span>';
        row.querySelector('.sd__product-title').textContent = p.title;
        row.querySelector('.sd__product-meta').textContent = productMeta(p);
        const priceEl = row.querySelector('.sd__product-price');
        if (p.price_min && p.price_max && p.price_min !== p.price_max) {
          // "od " prefix comes from the locale (ab.search.from), not from CSS
          const from = document.createElement('span');
          from.className = 'sd__product-from';
          from.textContent = (cfg.fromLabel || '') + ' ';
          priceEl.appendChild(from);
          priceEl.appendChild(document.createTextNode(money(p.price_min)));
        } else {
          priceEl.textContent = money(p.price);
        }
        productsEl.appendChild(row);
      });

      // Contextual COAL hint when the query names a caliber with a configurator
      const squashed = squash(query);
      const coalHit = coalCalibers.find((c) => squashed.includes(c.norm));
      if (coalHit && cfg.coalHint) {
        // coalHint carries <strong>COAL</strong> from the locale; the caliber label is escaped
        coalText.innerHTML = cfg.coalHint.replace('%s', escapeHtml(coalHit.label));
        coalEl.hidden = false;
      } else {
        coalEl.hidden = true;
      }
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearBtn.hidden = query.length === 0;
      lastQuery = query;
      keyboardPick = false;
      clearTimeout(timer);
      open();
      if (!query) {
        reset();
        return;
      }
      timer = setTimeout(() => runSearch(query), 200);
    });

    // Enter → results page with the canonical term
    form.addEventListener('submit', (e) => {
      const raw = input.value.trim();
      if (!raw) {
        e.preventDefault();
        return;
      }
      input.value = canonicalize(raw);
    });

    panel.querySelectorAll('[data-sd-chip]').forEach((chip) => {
      chip.addEventListener('click', () => {
        input.value = chip.textContent.trim();
        input.dispatchEvent(new Event('input'));
        input.focus();
      });
    });

    // Keep the header badge in sync after AJAX cart changes
    document.addEventListener('cart:updated', (e) => {
      const count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
      if (count === null) return;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-caliber"] && !Shopify.designMode) return;
  try {
    
  /* Spec 9a §2.2: the series bar switches the hero layer on hover (desktop pointer devices only) */
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const canSwitch = window.matchMedia('(hover: hover) and (min-width: 990px)');
    document.addEventListener('hero:series', (e) => {
      const key = (e.detail && e.detail.series) || '';
      if (!canSwitch.matches) return;
      const target = key && hero.querySelector('[data-hero-layer="' + key + '"]');
      hero.setAttribute('data-hero-active', target ? key : '');
      hero.querySelectorAll('.hero__layer--series').forEach((layer) => {
        layer.setAttribute('aria-hidden', layer === target ? 'false' : 'true');
      });
    });
  });

  document.querySelectorAll('.hero__finder').forEach((finder) => {
    const form = finder.querySelector('[data-caliber-search]');
    const input = finder.querySelector('.hero__search-input');
    const grid = finder.querySelector('[data-caliber-grid]');
    const dataEl = finder.querySelector('[data-caliber-data]');
    const emptyTpl = finder.querySelector('[data-caliber-empty]');
    if (!form || !input || !grid || !dataEl) return;

    const normalize = (s) =>
      s.toLowerCase().replace(/\s+/g, '').replace(/,/g, '.');

    // Type captions come from the locale (ab.hero.type_*); menu titles are only matched, never shown
    let typeLabels = {};
    try {
      typeLabels = JSON.parse(grid.dataset.caliberLabels || '{}');
    } catch (err) {
      typeLabels = {};
    }
    const groupLabel = (group) => {
      const g = group.toLowerCase();
      if (g.includes('pistol')) return typeLabels.pistol || group.toLowerCase();
      if (g.includes('karabin') || g.includes('rifle')) return typeLabels.rifle || group.toLowerCase();
      if (g.includes('śrut') || g.includes('strzelb') || g.includes('shotgun')) return typeLabels.shotgun || group.toLowerCase();
      return group.toLowerCase();
    };

    let calibers = Array.from(dataEl.querySelectorAll('a')).map((a) => ({
      title: a.textContent.trim(),
      norm: normalize(a.textContent),
      url: a.getAttribute('href'),
      group: a.dataset.group || '',
    }));

    // Fallback: no calibers menu configured — search among the popular tiles
    if (calibers.length === 0) {
      calibers = Array.from(grid.querySelectorAll('.hero__caliber')).map((tile) => ({
        title: (tile.querySelector('.hero__caliber-name') || tile).textContent.trim(),
        norm: normalize((tile.querySelector('.hero__caliber-name') || tile).textContent),
        url: tile.getAttribute('href'),
        group: tile.querySelector('.hero__caliber-type') ? tile.querySelector('.hero__caliber-type').textContent.trim() : '',
      }));
    }

    // Popular tiles without a configured link get their URL from the caliber
    // index (matched by name), so they never dead-end at "#".
    grid.querySelectorAll('.hero__caliber').forEach((tile) => {
      const href = tile.getAttribute('href');
      if (href && href !== '#' && href !== '') return;
      const nameEl = tile.querySelector('.hero__caliber-name') || tile;
      const norm = normalize(nameEl.textContent);
      const match =
        calibers.find((c) => c.norm === norm) || calibers.find((c) => c.norm.includes(norm));
      if (match) tile.setAttribute('href', match.url);
    });

    // Capture the default tiles without any scroll-reveal state, so restoring
    // them never brings back opacity-0 leftovers.
    const gridClone = grid.cloneNode(true);
    gridClone.querySelectorAll('[data-reveal]').forEach((el) => {
      el.removeAttribute('data-reveal');
      el.classList.remove('is-revealed');
      el.style.removeProperty('--reveal-index');
    });
    const defaultHTML = gridClone.innerHTML;
    let matches = [];

    const render = (query) => {
      if (!query) {
        grid.innerHTML = defaultHTML;
        matches = [];
        return;
      }
      matches = calibers.filter((c) => c.norm.includes(query));
      if (matches.length === 0) {
        grid.innerHTML = '';
        if (emptyTpl) grid.appendChild(emptyTpl.content.cloneNode(true));
        return;
      }
      grid.innerHTML = '';
      matches.slice(0, 6).forEach((c) => {
        const tile = document.createElement('a');
        tile.className = 'hero__caliber' + (c.title.length > 9 ? ' hero__caliber--long' : '');
        tile.href = c.url;
        tile.innerHTML =
          '<span class="ab-stencil hero__caliber-name"></span><span class="hero__caliber-type"></span>';
        // Same markup as snippets/caliber-label: the x between digits stays lowercase
        const nameEl = tile.querySelector('.hero__caliber-name');
        c.title.split(/(?<=\d)x/).forEach((part, i) => {
          if (i > 0) {
            const x = document.createElement('span');
            x.className = 'ab-x';
            x.textContent = 'x';
            nameEl.appendChild(x);
          }
          nameEl.appendChild(document.createTextNode(part));
        });
        tile.querySelector('.hero__caliber-type').textContent = groupLabel(c.group);
        grid.appendChild(tile);
      });
    };

    input.addEventListener('input', () => render(normalize(input.value)));

    // Restore the popular tiles when the query is cleared (keyboard, the
    // native "x" button of type=search) or the empty field loses focus.
    const resetIfEmpty = () => {
      if (!normalize(input.value)) render('');
    };
    input.addEventListener('search', resetIfEmpty);
    input.addEventListener('change', resetIfEmpty);
    input.addEventListener('blur', resetIfEmpty);

    // Enter: go straight to the best match instead of the generic search page
    form.addEventListener('submit', (e) => {
      if (matches.length > 0) {
        e.preventDefault();
        window.location.href = matches[0].url;
      } else if (calibers.length > 0 && normalize(input.value)) {
        e.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pdp]');
    const form = document.getElementById('pdp-form');
    if (!root || !form) return;
    const variants = JSON.parse(document.getElementById('pdp-variants-json').textContent);
    const money = (cents) => window.AB.money(cents);
    const optionButtons = root.querySelectorAll('[data-option-index][data-value]');
    const selections = [];
    root.querySelectorAll('.pdp__option[data-option-index]').forEach((opt) => {
      const idx = parseInt(opt.dataset.optionIndex, 10);
      const active = opt.querySelector('.pdp__swatch-btn--active, .pdp__cap-tile--active, .pdp__pill--active');
      selections[idx] = active ? active.dataset.value : null;
    });

    /* ---- Gallery (docs/Galeria-PDP-projekt-2026-11-01.md) ----
       Karuzela na natywnym scroll-snap, wszystkie miniatury, lupa 2x na komputerze,
       nakładka z zoomem (snippets/pdp-gallery-overlay.liquid). */
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const wideScreen = window.matchMedia('(min-width: 750px)');
    const finePointer = window.matchMedia('(pointer: fine)').matches;
    /* Przewijanie programowe: dopóki tor nie dojedzie do celu, zdarzenia scroll nie zmieniają aktywnego slajdu */
    const scrollTargets = new WeakMap();
    const programmaticScroll = (track, left) => {
      if (Math.abs(track.scrollLeft - left) < 2) return;
      scrollTargets.set(track, { left, until: performance.now() + 700 });
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const isProgrammatic = (track) => {
      const t = scrollTargets.get(track);
      if (!t) return false;
      if (Math.abs(track.scrollLeft - t.left) < 2 || performance.now() > t.until) {
        scrollTargets.delete(track);
        return false;
      }
      return true;
    };
    /* Miniatura aktywna do środka paska, bez przewijania strony (scrollIntoView przewinęłoby dokument) */
    const centerThumb = (strip, thumb) => {
      if (!strip || !thumb || strip.scrollWidth <= strip.clientWidth) return;
      strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    /* ---- Nakładka ---- */
    const overlay = document.querySelector('[data-pdp-overlay]'); /* snippet renderowany za .pdp, obok JSON-ów */
    const openOverlay = (startIndex, returnFocus, onClose) => {
      if (!overlay) return;
      if (overlay.parentElement !== document.body) document.body.appendChild(overlay); /* fixed względem okna, nie sekcji */
      const ac = new AbortController();
      const on = (el, ev, fn, opts) => el.addEventListener(ev, fn, Object.assign({ signal: ac.signal }, opts || {}));
      const viewport = overlay.querySelector('[data-ov-viewport]');
      const track = overlay.querySelector('[data-ov-track]');
      const slides = [...overlay.querySelectorAll('.abo__slide')];
      const thumbs = [...overlay.querySelectorAll('[data-ov-thumb]')];
      const thumbStrip = overlay.querySelector('[data-ov-thumbs]');
      const counter = overlay.querySelector('[data-ov-counter]');
      const prev = overlay.querySelector('[data-ov-prev]');
      const next = overlay.querySelector('[data-ov-next]');
      const n = slides.length;
      let index = clamp(startIndex, 0, n - 1);
      const Z = { s: 1, tx: 0, ty: 0 };
      /* slajd filmu bez zoomu (video_tag ma w środku zapasowy <img> z plakatem) */
      const activeImg = () => slides[index].classList.contains('abo__slide--video') ? null : slides[index].querySelector('img');
      const fit = () => {
        const im = activeImg();
        if (!im) return null;
        const sr = slides[index].getBoundingClientRect();
        const w = im.offsetWidth;
        const h = im.offsetHeight;
        return { w, h, ox: (sr.width - w) / 2, oy: (sr.height - h) / 2, sw: sr.width, sh: sr.height };
      };
      /* Limit zoomu = piksele natywne pliku (bez pikselozy); min 1,5x, żeby zoom w ogóle działał na małych plikach */
      const maxScale = () => {
        const im = activeImg();
        const f = fit();
        if (!im || !f || !f.w) return 1;
        const native = parseInt(im.dataset.native, 10) || im.naturalWidth || 1600;
        return clamp(native / f.w, 1.5, 4);
      };
      const setTrack = (dx, anim) => {
        track.classList.toggle('abo__track--anim', !!anim && !reduceMotion);
        track.style.transform = `translate3d(calc(${-index * 100}% + ${dx || 0}px), 0, 0)`;
      };
      const apply = (anim) => {
        const im = activeImg();
        if (!im) return;
        const f = fit();
        const sw = f.w * Z.s;
        const sh = f.h * Z.s;
        /* Mniejsze od kadru = wyśrodkuj; większe = brzegi zdjęcia nie wchodzą do kadru */
        Z.tx = sw <= f.sw ? (f.sw - sw) / 2 - f.ox : clamp(Z.tx, f.sw - sw - f.ox, -f.ox);
        Z.ty = sh <= f.sh ? (f.sh - sh) / 2 - f.oy : clamp(Z.ty, f.sh - sh - f.oy, -f.oy);
        slides[index].classList.toggle('abo__slide--anim', !!anim && !reduceMotion);
        im.style.transform = `translate(${Z.tx}px, ${Z.ty}px) scale(${Z.s})`;
        const zoomed = Z.s > 1.01;
        slides[index].classList.toggle('abo__slide--zoomed', zoomed);
        overlay.classList.toggle('abo--zoomed', zoomed);
      };
      const resetZoom = () => {
        Z.s = 1;
        Z.tx = 0;
        Z.ty = 0;
        slides.forEach((s) => {
          s.classList.remove('abo__slide--zoomed', 'abo__slide--anim');
          const im = s.querySelector('img');
          if (im) im.style.transform = '';
        });
        overlay.classList.remove('abo--zoomed');
      };
      const zoomAt = (s, px, py, anim) => {
        const f = fit();
        if (!f) return;
        const ns = clamp(s, 1, maxScale());
        const k = ns / Z.s;
        /* Punkt pod kursorem zostaje w miejscu */
        Z.tx = px - f.ox - (px - f.ox - Z.tx) * k;
        Z.ty = py - f.oy - (py - f.oy - Z.ty) * k;
        Z.s = ns;
        apply(anim);
      };
      const slidePoint = (e) => {
        const r = slides[index].getBoundingClientRect();
        return [e.clientX - r.left, e.clientY - r.top];
      };
      const setActive = (i, anim) => {
        if (i !== index) resetZoom();
        index = clamp(i, 0, n - 1);
        overlay.classList.toggle('abo--video', slides[index].classList.contains('abo__slide--video'));
        setTrack(0, anim);
        thumbs.forEach((t, k) => t.setAttribute('aria-pressed', k === index ? 'true' : 'false'));
        if (counter) counter.textContent = `${index + 1} / ${n}`;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === n - 1;
        centerThumb(thumbStrip, thumbs[index]);
        slides.forEach((s, k) => {
          const v = s.querySelector('video');
          if (v && k !== index) v.pause();
          const im = s.querySelector('img');
          if (im && Math.abs(k - index) <= 1) im.loading = 'eager'; /* bieżące + sąsiednie od razu */
        });
      };
      const goTo = (i) => setActive(i, true);

      /* Wskaźnik: klik / dwuklik / przeciąganie / pinch / swipe (touch-action: none, obsługa własna) */
      const pointers = new Map();
      let pinch0 = null;
      let swipe = null;
      let moved = false;
      let lastTap = 0;
      let downAt = 0;
      let downTarget = null; /* po setPointerCapture celem pointerup jest viewport, więc cel zapamiętujemy przy wciśnięciu */
      on(viewport, 'pointerdown', (e) => {
        if (e.target.closest('button, video')) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        moved = false;
        downAt = performance.now();
        downTarget = e.target;
        if (pointers.size === 2) {
          const [a, b] = [...pointers.values()];
          pinch0 = { d: Math.hypot(a.x - b.x, a.y - b.y), s: Z.s };
          swipe = null;
        } else if (pointers.size === 1 && Z.s <= 1.01 && e.pointerType !== 'mouse') {
          swipe = { x: e.clientX, t: performance.now() };
        }
        viewport.setPointerCapture(e.pointerId);
      });
      on(viewport, 'pointermove', (e) => {
        if (!pointers.has(e.pointerId)) {
          /* Komputer: po powiększeniu zdjęcie podąża za kursorem */
          if (finePointer && Z.s > 1 && e.pointerType === 'mouse' && e.target.closest('img')) {
            const f = fit();
            const [px, py] = slidePoint(e);
            const rx = clamp(px / f.sw, 0, 1);
            const ry = clamp(py / f.sh, 0, 1);
            Z.tx = -f.ox + rx * (f.sw - f.w * Z.s);
            Z.ty = -f.oy + ry * (f.sh - f.h * Z.s);
            apply(false);
          }
          return;
        }
        const p = pointers.get(e.pointerId);
        const dx = e.clientX - p.x;
        const dy = e.clientY - p.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
        if (pointers.size === 2 && pinch0) {
          pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
          const [a, b] = [...pointers.values()];
          const d = Math.hypot(a.x - b.x, a.y - b.y);
          const r = slides[index].getBoundingClientRect();
          zoomAt(pinch0.s * (d / pinch0.d), (a.x + b.x) / 2 - r.left, (a.y + b.y) / 2 - r.top, false);
          return;
        }
        if (Z.s > 1 && e.pointerType !== 'mouse') {
          Z.tx += dx;
          Z.ty += dy;
          pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
          apply(false);
        } else if (swipe) {
          setTrack(e.clientX - swipe.x, false);
        }
      });
      const up = (e) => {
        const wasPinch = pointers.size === 2;
        pointers.delete(e.pointerId);
        if (pointers.size < 2) pinch0 = null;
        if (swipe) {
          const dx = e.clientX - swipe.x;
          const w = viewport.clientWidth || 1;
          const fast = Math.abs(dx) / Math.max(1, performance.now() - swipe.t) > 0.5;
          swipe = null;
          if (Math.abs(dx) > w * 0.2 || (fast && Math.abs(dx) > 24)) {
            const to = clamp(index + (dx < 0 ? 1 : -1), 0, n - 1);
            setActive(to, true);
          } else {
            setTrack(0, true);
          }
          if (moved) return;
        }
        if (wasPinch || moved || !downTarget || !downTarget.closest('img')) return;
        if (performance.now() - downAt > 400) return;
        const [px, py] = slidePoint(e);
        if (e.pointerType === 'mouse') {
          if (Z.s > 1) { resetZoom(); apply(true); } else zoomAt(2.5, px, py, true);
        } else {
          const now = performance.now();
          if (now - lastTap < 320) {
            if (Z.s > 1) { resetZoom(); apply(true); } else zoomAt(2.5, px, py, true);
            lastTap = 0;
          } else lastTap = now;
        }
      };
      on(viewport, 'pointerup', up);
      on(viewport, 'pointercancel', (e) => { pointers.delete(e.pointerId); pinch0 = null; if (swipe) { swipe = null; setTrack(0, true); } });
      on(viewport, 'wheel', (e) => {
        if (!e.target.closest('img')) return;
        e.preventDefault();
        const [px, py] = slidePoint(e);
        zoomAt(Z.s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), px, py, false);
      }, { passive: false });
      on(window, 'resize', () => { setTrack(0, false); if (Z.s > 1) apply(false); });

      if (prev) on(prev, 'click', () => goTo(index - 1));
      if (next) on(next, 'click', () => goTo(index + 1));
      thumbs.forEach((t) => on(t, 'click', () => goTo(parseInt(t.dataset.index, 10))));
      overlay.querySelectorAll('[data-ov-zoom]').forEach((b) => on(b, 'click', () => {
        const f = fit();
        if (f) zoomAt(Z.s + parseInt(b.dataset.ovZoom, 10) * 0.75, f.sw / 2, f.sh / 2, true);
      }));

      const scroller = document.documentElement;
      const prevOverflow = scroller.style.overflow;
      scroller.style.overflow = 'hidden';
      const close = () => {
        ac.abort();
        resetZoom();
        slides.forEach((s) => { const v = s.querySelector('video'); if (v) v.pause(); });
        overlay.hidden = true;
        scroller.style.overflow = prevOverflow;
        if (onClose) onClose(index);
        if (returnFocus) returnFocus.focus({ preventScroll: true });
      };
      const focusables = () => [...overlay.querySelectorAll('button:not(:disabled), video[controls]')];
      on(document, 'keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        else if (e.key === '+' || e.key === '=') { const f = fit(); if (f) zoomAt(Z.s + 0.75, f.sw / 2, f.sh / 2, true); }
        else if (e.key === '-') { const f = fit(); if (f) zoomAt(Z.s - 0.75, f.sw / 2, f.sh / 2, true); }
        else if (e.key === 'Tab') {
          const f = focusables();
          if (!f.length) return;
          const first = f[0];
          const last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }, { capture: true });
      on(overlay.querySelector('[data-ov-close]'), 'click', close);

      overlay.hidden = false;
      setActive(index, false);
      overlay.querySelector('[data-ov-close]').focus({ preventScroll: true });
    };

    /* ---- Slajd „z amunicją” z metapola wariantu: podmiana obrazu przy zmianie koloru ----
       Nakładka po pierwszym otwarciu siedzi w <body>, więc szukamy po całym dokumencie */
    const nabojeMap = (() => {
      const el = root.querySelector('[data-naboje-map]');
      try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
    })();
    const swapNaboje = (variantId) => {
      const v = nabojeMap[String(variantId)];
      if (!v) return;
      /* naboje: slajd „z amunicją” (metapole wariantu); wymiary: ostatnie medium podmieniane renderem w kolorze */
      ['naboje', 'wymiary'].forEach((key) => {
        const d = v[key];
        if (!d) return;
        document.querySelectorAll(`[data-${key}-img]`).forEach((img) => {
          const kind = img.dataset[`${key}Img`];
          if (kind === 'slide') {
            if (img.src === d.s1400) return;
            img.srcset = `${d.s480} 480w, ${d.s800} 800w, ${d.s1100} 1100w, ${d.s1400} 1400w`;
            img.src = d.s1400;
            img.alt = d.alt;
          } else if (kind === 'thumb') {
            img.src = d.s200;
          } else if (kind === 'ov') {
            img.src = d.s2000;
            img.alt = d.alt;
            img.dataset.native = d.w;
          } else if (kind === 'ov-thumb') {
            img.src = d.s160;
          }
        });
      });
    };

    /* ---- Karuzela na karcie ---- */
    const gallery = (() => {
      const g = root.querySelector('[data-pdp-gallery]');
      if (!g) return null;
      const track = g.querySelector('.abg__track');
      const slides = [...g.querySelectorAll('.abg__slide')];
      const thumbs = [...g.querySelectorAll('[data-gallery-thumb]')];
      const thumbStrip = g.querySelector('[data-gallery-thumbs]');
      const prev = g.querySelector('[data-gallery-prev]');
      const next = g.querySelector('[data-gallery-next]');
      const counter = g.querySelector('[data-gallery-counter]');
      const loupe = g.querySelector('[data-gallery-loupe]');
      const n = slides.length;
      if (!n) return null;
      let index = clamp(parseInt(g.dataset.start || '0', 10) || 0, 0, n - 1);
      /* Film: wyciszony i w pętli, więc gra sam, gdy jego slajd jest aktywny (jak przed zmianą galerii);
         klik w film lub przycisk pauzuje — do ponownego wejścia na slajd */
      const playVideo = (s) => {
        const v = s.querySelector('video');
        if (!v || !v.paused) return;
        s.classList.add('abg__slide--playing'); /* przycisk znika od razu, nie dopiero po pobraniu pliku */
        v.play().catch(() => s.classList.remove('abg__slide--playing'));
      };
      const pauseVideo = (s) => {
        const v = s.querySelector('video');
        if (v && !v.paused) v.pause();
        s.classList.remove('abg__slide--playing');
      };
      const stopVideos = (except) => slides.forEach((s) => { if (s !== except) pauseVideo(s); });
      const setActive = (i, fromScroll) => {
        index = clamp(i, 0, n - 1);
        thumbs.forEach((t, k) => t.setAttribute('aria-pressed', k === index ? 'true' : 'false'));
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === n - 1;
        if (counter) counter.textContent = `${index + 1} / ${n}`;
        if (!wideScreen.matches) centerThumb(thumbStrip, thumbs[index]);
        if (!fromScroll) programmaticScroll(track, slides[index].offsetLeft);
        stopVideos(slides[index]);
        const isVideo = slides[index].classList.contains('abg__slide--video');
        g.classList.toggle('abg--video', isVideo);
        if (isVideo) { slides[index].dataset.userPaused = ''; playVideo(slides[index]); }
        g.classList.remove('abg--loupe-on');
      };
      const goTo = (i) => setActive(i, false);
      const goToMedia = (mediaId) => {
        const k = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (k >= 0 && k !== index) goTo(k);
      };

      /* Start od zdjęcia wariantu z adresu (?variant=) bez animacji */
      if (index > 0) track.scrollLeft = slides[index].offsetLeft;

      let scrollTimer;
      track.addEventListener('scroll', () => {
        if (isProgrammatic(track)) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index) setActive(i, true);
        }, 80);
      }, { passive: true });
      if (prev) prev.addEventListener('click', () => goTo(index - 1));
      if (next) next.addEventListener('click', () => goTo(index + 1));
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(parseInt(t.dataset.index, 10))));

      const open = () => {
        stopVideos();
        openOverlay(index, track, (i) => goTo(i));
      };
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        else if (e.key === 'Enter') open();
      });
      slides.forEach((s) => {
        const btn = s.querySelector('[data-gallery-play]');
        if (btn) {
          /* preload="none": plik pobiera się dopiero, gdy slajd filmu staje się aktywny */
          const v = s.querySelector('video');
          const toggle = () => {
            if (v.paused) { s.dataset.userPaused = ''; playVideo(s); }
            else { s.dataset.userPaused = '1'; pauseVideo(s); }
          };
          btn.addEventListener('click', toggle);
          v.addEventListener('click', toggle);
          if ('IntersectionObserver' in window) {
            /* poza ekranem pauza; po powrocie gra dalej, o ile klient sam go nie zatrzymał */
            new IntersectionObserver(([entry]) => {
              if (!entry.isIntersecting) pauseVideo(s);
              else if (s === slides[index] && s.dataset.userPaused !== '1') playVideo(s);
            }, { threshold: 0.4 }).observe(s);
          }
        } else if (s.querySelector('img')) {
          s.addEventListener('click', open);
        }
      });
      const zoomBtn = g.querySelector('[data-gallery-zoom]');
      if (zoomBtn) zoomBtn.addEventListener('click', open);

      /* Lupa 2x przy najechaniu (komputer): plik 1600 px ładuje się dopiero przy pierwszym najechaniu,
         zwłoka 140 ms, żeby przejazd kursorem do strzałki jej nie włączał */
      if (loupe) {
        const stage = g.querySelector('.abg__stage');
        let loupeTimer;
        stage.addEventListener('pointermove', (e) => {
          if (!wideScreen.matches || e.pointerType !== 'mouse') return;
          /* slajd filmu bez lupy: video_tag Shopify ma w środku zapasowy <img> z plakatem, więc samo querySelector('img') nie wystarczy */
          const img = slides[index].classList.contains('abg__slide--video') ? null : slides[index].querySelector('img');
          if (!img || e.target.closest('button')) { g.classList.remove('abg--loupe-on'); return; }
          const r = stage.getBoundingClientRect();
          const x = clamp((e.clientX - r.left) / r.width, 0, 1) * 100;
          const y = clamp((e.clientY - r.top) / r.height, 0, 1) * 100;
          const src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=1600');
          const url = `url("${src}")`;
          if (loupe.style.backgroundImage !== url) loupe.style.backgroundImage = url;
          loupe.style.backgroundPosition = `${x}% ${y}%`;
          if (!g.classList.contains('abg--loupe-on')) {
            clearTimeout(loupeTimer);
            loupeTimer = setTimeout(() => g.classList.add('abg--loupe-on'), 140);
          }
        });
        stage.addEventListener('pointerleave', () => { clearTimeout(loupeTimer); g.classList.remove('abg--loupe-on'); });
      }

      /* Podpowiedź zoomu na telefonie: 3 s, raz na sesję */
      const hint = g.querySelector('[data-gallery-hint]');
      if (hint && !wideScreen.matches && !slides[index].classList.contains('abg__slide--video')) {
        let hinted = false;
        try { hinted = sessionStorage.getItem('abg-hint') === '1'; } catch (e) { /* bez storage: pokaż */ }
        if (!hinted) {
          setTimeout(() => g.classList.add('abg--hint'), 600);
          setTimeout(() => {
            g.classList.remove('abg--hint');
            try { sessionStorage.setItem('abg-hint', '1'); } catch (e) {}
          }, 3600);
        }
      }

      setActive(index, true);
      return { goTo, goToMedia };
    })();

    /* ---- Quantity (main + sticky stay in sync) ---- */
    const qtyInputs = root.querySelectorAll('[data-pdp-qty]');
    const setQty = (value) => {
      const v = Math.max(1, parseInt(value || '1', 10) || 1);
      qtyInputs.forEach((i) => (i.value = v));
    };
    root.addEventListener('click', (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (!step) return;
      const input = step.parentElement.querySelector('[data-pdp-qty]');
      setQty(parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10));
    });
    qtyInputs.forEach((i) => i.addEventListener('change', () => setQty(i.value)));

    /* ---- Variant selection ---- */
    const priceEl = root.querySelector('[data-pdp-price]');
    const stockEl = root.querySelector('[data-pdp-stock]');
    const addBtn = root.querySelector('[data-pdp-add]');
    const addLabel = root.querySelector('[data-pdp-add-label]');
    const stickyAdd = root.querySelector('[data-pdp-sticky-add]');
    const stickyLabel = root.querySelector('[data-pdp-sticky-label]');
    const stickyPrice = root.querySelector('[data-pdp-sticky-price]');
    const stickyTemplate = stickyPrice ? stickyPrice.dataset.template || '%p' : '%p';

    const pulsePrice = () => {
      if (!priceEl) return;
      priceEl.classList.remove('pdp__price--pulse');
      void priceEl.offsetWidth;
      priceEl.classList.add('pdp__price--pulse');
    };

    const findVariant = (sel) => variants.find((v) => sel.every((s, i) => s === null || v.options[i] === s));

    const isDisabled = (el) => el.disabled || el.getAttribute('aria-disabled') === 'true';

    const updateCapTiles = () => {
      const capOpt = root.querySelector('.pdp__option[data-capacity]');
      if (!capOpt) return;
      const capIdx = parseInt(capOpt.dataset.optionIndex, 10);
      capOpt.querySelectorAll('.pdp__cap-tile').forEach((tile) => {
        const trial = selections.slice();
        trial[capIdx] = tile.dataset.value;
        const v = findVariant(trial);
        const priceSpan = tile.querySelector('.pdp__cap-price');
        if (priceSpan) priceSpan.textContent = v ? money(v.price) : '';
        const unavailable = !v || !v.available;
        const srText = tile.querySelector('[data-cap-unavailable-text]');
        tile.classList.toggle('pdp__cap-tile--unavailable', unavailable);
        /* aria-disabled (not `disabled`) keeps the tile focusable so the hidden text is announced */
        if (unavailable && !tile.classList.contains('pdp__cap-tile--active')) {
          tile.setAttribute('aria-disabled', 'true');
        } else {
          tile.removeAttribute('aria-disabled');
        }
        if (srText) srText.hidden = !unavailable;
      });
    };

    const updateVariant = () => {
      updateCapTiles();
      const match = findVariant(selections);
      if (!match) {
        addBtn.disabled = true;
        addLabel.textContent = addBtn.dataset.labelUnavailable;
        if (stickyAdd) stickyAdd.disabled = true;
        if (stickyLabel) stickyLabel.textContent = stickyLabel.dataset.labelUnavailable;
        return;
      }
      document.getElementById('pdp-variant-id').value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      pulsePrice();
      addBtn.disabled = !match.available;
      addLabel.textContent = match.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelUnavailable;
      if (stickyAdd) stickyAdd.disabled = !match.available;
      if (stickyLabel) stickyLabel.textContent = match.available ? stickyLabel.dataset.labelAdd : stickyLabel.dataset.labelUnavailable;
      if (stickyPrice) stickyPrice.textContent = stickyTemplate.replace('%p', money(match.price));
      if (stockEl) {
        stockEl.querySelector('span').textContent = match.available ? stockEl.dataset.labelIn : stockEl.dataset.labelOut;
      }
      // Spec 11b: the metadata line mirrors the selected capacity (variant model)
      const capMeta = root.querySelector('[data-pdp-cap-meta]');
      const capOptEl = root.querySelector('.pdp__option[data-capacity]');
      if (capMeta && capOptEl) {
        const capIdx = parseInt(capOptEl.dataset.optionIndex, 10);
        if (!isNaN(capIdx) && selections[capIdx]) capMeta.textContent = selections[capIdx];
      }
      // Zdjęcie wariantu jest jednym ze slajdów galerii: przewijamy do niego zamiast podmieniać plik
      if (gallery && match.featured_media && match.featured_media.id) gallery.goToMedia(match.featured_media.id);
      // Slajd „z amunicją” pokazuje render w kolorze wybranego wariantu (karta i nakładka)
      swapNaboje(match.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (isDisabled(btn)) return;
        const idx = parseInt(btn.dataset.optionIndex, 10);
        selections[idx] = btn.dataset.value;
        const group = btn.closest('.pdp__option');
        group.querySelectorAll('[data-option-index]').forEach((b) => {
          b.classList.remove('pdp__swatch-btn--active', 'pdp__cap-tile--active', 'pdp__pill--active');
          b.setAttribute('aria-pressed', 'false');
        });
        if (btn.classList.contains('pdp__swatch-btn')) btn.classList.add('pdp__swatch-btn--active');
        else if (btn.classList.contains('pdp__cap-tile')) btn.classList.add('pdp__cap-tile--active');
        else btn.classList.add('pdp__pill--active');
        btn.setAttribute('aria-pressed', 'true');
        const valueEl = group.querySelector('[data-option-value]');
        if (valueEl) valueEl.textContent = btn.dataset.value;
        updateVariant();
      });
    });
    updateCapTiles();

    /* ---- Add to cart → drawer (no redirect, spec §5) ---- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const buttons = [addBtn, stickyAdd].filter(Boolean);
      buttons.forEach((b) => (b.disabled = true));
      try {
        await window.AB.cart.add(new FormData(form), { trigger: e.submitter || addBtn });
      } catch (err) {
        window.AB.toast((err && err.message) || window.AB.t.error);
      } finally {
        buttons.forEach((b) => (b.disabled = false));
        updateVariant();
      }
    });

    /* ---- Long description clamp (spec §4.2) ---- */
    root.querySelectorAll('[data-clamp]').forEach((clamp) => {
      const body = clamp.querySelector('.ab-clamp__body');
      const toggle = clamp.querySelector('[data-clamp-toggle]');
      if (!body || !toggle) return;
      const label = toggle.querySelector('[data-clamp-label]') || toggle;
      const check = () => {
        if (!clamp.classList.contains('ab-clamp--open') && body.scrollHeight <= 160) clamp.classList.add('ab-clamp--short');
      };
      check();
      window.addEventListener('load', check, { once: true });
      toggle.addEventListener('click', () => {
        const open = clamp.classList.toggle('ab-clamp--open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        label.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        if (!open) clamp.scrollIntoView({ block: 'nearest' });
      });
    });

    /* ---- "Wszystkie opinie" sits inside <summary>: follow the link, never collapse the section ---- */
    root.querySelectorAll('[data-pdp-reviews-all]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        const details = link.closest('details');
        if (details) setTimeout(() => (details.open = true), 0);
      });
    });

    /* ---- Sticky mobile CTA (mockup 7b): shown whenever the inline CTA is not in the viewport ---- */
    const sticky = root.querySelector('[data-pdp-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          sticky.hidden = entries[0].isIntersecting;
        },
        { threshold: 0 }
      );
      io.observe(addBtn);
    } else if (sticky) {
      sticky.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const grid = document.querySelector('[data-sr-grid]');
    const chipsEl = document.querySelector('[data-sr-chips]');
    if (!grid || !chipsEl) return;
    const cards = Array.from(grid.querySelectorAll('.sr__card'));
    if (cards.length === 0) return;

    const counts = new Map();
    cards.forEach((card) => {
      [card.dataset.series, card.dataset.cap].forEach((value) => {
        if (value) counts.set(value, (counts.get(value) || 0) + 1);
      });
    });

    let active = null;
    const applyFilter = () => {
      cards.forEach((card) => {
        card.hidden =
          active !== null && card.dataset.series !== active && card.dataset.cap !== active;
      });
      chipsEl.querySelectorAll('.sr__chip').forEach((chip) => {
        chip.classList.toggle('sr__chip--active', chip.dataset.value === (active || ''));
      });
    };

    const makeChip = (label, value) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'sr__chip';
      chip.dataset.value = value;
      chip.textContent = label;
      chip.addEventListener('click', () => {
        active = value === '' ? null : value;
        applyFilter();
      });
      chipsEl.appendChild(chip);
    };

    makeChip('Wszystko (' + cards.length + ')', '');
    counts.forEach((count, value) => makeChip(value + ' (' + count + ')', value));
    applyFilter();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["series-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-series-bar][data-hero-switch]').forEach((bar) => {
    const canSwitch = window.matchMedia('(hover: hover) and (min-width: 990px)');
    const emit = (series) => document.dispatchEvent(new CustomEvent('hero:series', { detail: { series } }));
    bar.querySelectorAll('[data-hero-series]').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (canSwitch.matches) emit(item.dataset.heroSeries);
      });
      item.addEventListener('mouseleave', () => {
        if (canSwitch.matches) emit('');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
